module.exports = __webpack_public_path__ + "static/media/DROP_OFF.98bcedb5.svg";